import create from 'zustand';

import { MediaApprovalMaStatus, MediaApprovalMaType } from '../graphql/query/moderate.queries';

export type DateRangeType = 'today' | 'lastWeek' | 'lastMonth' | 'oldest' | null;

export interface ModerateFilters {
  dateRange: DateRangeType;
  contentTypes: MediaApprovalMaType[];
  categories: string[];
  status: MediaApprovalMaStatus;
}

interface ModerateState {
  filters: ModerateFilters;
  setFilters: (filters: Partial<ModerateFilters>) => void;
  resetFilters: () => void;
}

const DEFAULT_FILTERS: ModerateFilters = {
  dateRange: null,
  contentTypes: [],
  categories: [],
  status: 'PENDING',
};

export const useModerateStore = create<ModerateState>((set) => ({
  filters: { ...DEFAULT_FILTERS },
  setFilters: (newFilters) =>
    set((state) => ({
      filters: { ...state.filters, ...newFilters },
    })),
  resetFilters: () =>
    set({
      filters: { ...DEFAULT_FILTERS },
    }),
}));
